module.exports = __webpack_public_path__ + "img/article-free-logo.1d7c6eaa.png";